import { render, staticRenderFns } from "./saleamountBottom.vue?vue&type=template&id=13b0e38a&scoped=true&"
import script from "./saleamountBottom.vue?vue&type=script&lang=js&"
export * from "./saleamountBottom.vue?vue&type=script&lang=js&"
import style0 from "./saleamountBottom.vue?vue&type=style&index=0&id=13b0e38a&prod&lang=scss&scoped=true&"
import style1 from "./saleamountBottom.vue?vue&type=style&index=1&id=13b0e38a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b0e38a",
  null
  
)

export default component.exports